export { RENDERER_TYPE, checkboxRenderer } from "./checkboxRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/checkboxRenderer/index.mjs
// module id = 570
// module chunks = 1